import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import CheckoutTitle from './components/checkout.title';
import PurchaseOrderTableHeader from './components/checkout.purchase-order-table-header';
import DialogPolicy from './components/checkout.dialog-policy';
import DialogSFPlusInfo from './components/checkout.dialog-sf-plus-info';
import DialogSfPlusVlidatePin from './components/checkout.dialog-input-pin';
import LayoutPreloadTransparent from '../Preload/layout.preload-transparent';
import DialogCreateAddress from '../Address/address.dialog-create';
import DialogCreateTaxAddress from '../Address/tax-address.dialog-create';
import DialogPhoneNumber from './components/checkout.dialog-phone-number';
import DialogFurtherInformation from './components/checkout.form-further-information';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from '../../store/actions';
import {
  API,
  CURRENCY,
  PAYMENT_TYPE,
  KBANK,
  CONST_2C2P,
  BANK_INVOICE,
  SHIPPING_SELECT,
  TYPE_USAGE,
  TYPE_PROMOTION
} from '../../constants';
import { formatMoney } from '../../services';
import classNames from 'classnames';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import './checkout.css';
import CheckoutEmpty from './components/checkout.empty';
import { firstUpperCase, pad } from '../../utils/';
import DialogThaiQR from './components/checkout.dialog-thaiqr';
import SelectShipping from './components/checkout.select-shipping';
import KPayment from "./components/checkout.kpayment";

class CheckoutMain extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shippingAddress: {
        address: '',
        cardMember: '',
        district: '',
        subDistrict: '',
        email: '',
        id: '',
        lastName: '',
        name: '',
        phoneNumber: '',
        province: '',
        zipCode: ''
      },
      switchShippingAddress: false,
      radioShippingAddress: '0',
      taxInvoiceAddress: {
        id: '',
        name: '',
        lastName: '',
        phoneNumber: '',
        email: '',
        address: '',
        district: '',
        subbdistrict: '',
        province: '',
        zipCode: '',
        taxId: ''
      },
      TaxInvoiceCheckbox: false,
      switchTaxInvoiceAddress: false,
      radioTaxInvoiceAddress: '0',
      paymentMethod: [
        { id: 'credit-card', name: 'Credit / Debit Card' },
        { id: 'sf-plus', name: 'SF Plus' },
        { id: 'qrcode', name: 'QR Code' }
      ],
      paymentMethodSelected: 0,
      btnPurchaseState: true,
      shippingCost: 0,
      freeShipping: false,
      emailShipping: false,
      subTotal: 0,
      checkOutData: this.props.checkOutData,
      colorselected: this.props.colorselected,
      sizeselected: this.props.sizeselected,
      promotiontotal: this.props.promotiontotal,
      promotionCartSelected: this.props.promotionCartSelected,
      promotionprice: 0,
      radioShippingSelected: SHIPPING_SELECT.POST_OFFICE,
      dataShippingBranch: {
        phoneNumber: "",
        branchId: "",
        isValid: false,
        errors: null
      },
      showKbankpaymentDialog: false,
    };
  }

  async componentDidMount() {
    const { userAddress, userTaxInvoiceAddress, GetPaymentType, GetAddress, buyNow, UpdatePromotion, checkOutData, promotionCartSelected } = this.props;
    window.scrollTo(0, 0);
    let emailShipping = checkOutData?.every(item => item.type === "voucher") || false;
    let freeShipping = false;
    let subTotal = this.handleSubtotal(checkOutData, promotionCartSelected);
    this.setState({
      emailShipping,
      freeShipping,
      subTotal,
      checkOutData
    });
    await GetAddress();
    await GetPaymentType();
    UpdatePromotion(checkOutData?.map(item => item.itemId));

    if (userAddress && userAddress.length > 0 && !emailShipping) {
      const userAddressDefault = await _.filter(
        userAddress,
        add => add.isDefault === 'Y'
      );
      const radioShippingAddressSelected = await _.findIndex(
        userAddress,
        add => add.isDefault === 'Y'
      );
      await this.setState(prevSt => ({
        ...prevSt,
        shippingAddress:
          userAddressDefault.length === 0
            ? { ...this.props.userAddress[0] }
            : { ...userAddressDefault[0] },
        radioShippingAddress: radioShippingAddressSelected
      }));
    }

    if (userTaxInvoiceAddress && userTaxInvoiceAddress.length > 0) {
      const userTaxInvoiceAddressDefault = _.filter(
        userTaxInvoiceAddress,
        tiadd => tiadd.isDefault === 'Y'
      );
      const radioTaxInvoiceAddressSelected = _.findIndex(
        userTaxInvoiceAddress,
        tiadd => tiadd.isDefault === 'Y'
      );
      await this.setState(prevSt => ({
        ...prevSt,
        taxInvoiceAddress: { ...userTaxInvoiceAddressDefault[0] },
        radioTaxInvoiceAddress: radioTaxInvoiceAddressSelected
      }));
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    if (!_.isEqual(prevState.shippingAddress?.province, this.state.shippingAddress.province)
      || !_.isEqual(prevState.freeShipping, this.state.freeShipping)) {
      this.handleShippingCost();
    }

    if (!_.isEqual(prevProps.firebaseAuth, this.props.firebaseAuth)) {
      const { GetAddress, UpdatePromotion } = this.props;
      const { checkOutData } = this.state;
      await GetAddress();
      await UpdatePromotion(checkOutData.map(item => item.itemId));
    }

    if (!_.isEqual(prevProps.userAddress, this.props.userAddress)) {
      if (this.props.userAddress && this.props.userAddress.length > 0 && !this.state.emailShipping) {
        const { switchShippingAddress } = this.state;
        const userAddressDefault = await _.filter(
          this.props.userAddress,
          add => add.isDefault === 'Y'
        );
        const radioShippingAddressSelected = await _.findIndex(
          this.props.userAddress,
          add => add.isDefault === 'Y'
        );
        await this.setState(prevSt => ({
          ...prevSt,
          shippingAddress:
            userAddressDefault.length === 0
              ? { ...this.props.userAddress[0] }
              : { ...userAddressDefault[0] },
          radioShippingAddress: switchShippingAddress
            ? this.props.userAddress.length - 1
            : radioShippingAddressSelected
        }));
      }
    }

    if (!_.isEqual(prevProps.userTaxInvoiceAddress, this.props.userTaxInvoiceAddress)) {
      if (
        this.props.userTaxInvoiceAddress &&
        this.props.userTaxInvoiceAddress.length > 0
      ) {
        const { switchTaxInvoiceAddress } = this.state;
        const userTaxInvoiceAddressDefault = _.filter(
          this.props.userTaxInvoiceAddress,
          tiadd => tiadd.isDefault === 'Y'
        );
        const radioTaxInvoiceAddressSelected = _.findIndex(
          this.props.userTaxInvoiceAddress,
          tiadd => tiadd.isDefault === 'Y'
        );
        this.setState(prevSt => ({
          ...prevSt,
          taxInvoiceAddress: { ...userTaxInvoiceAddressDefault[0] },
          radioTaxInvoiceAddress: switchTaxInvoiceAddress
            ? this.props.userTaxInvoiceAddress.length - 1
            : radioTaxInvoiceAddressSelected
        }));
      }
    }
  }

  componentWillUnmount() {
    this.props.ClearDiscountCode();
  }

  handleRadioAddressChange = (name, index) => {
    this.setState({ [name]: index });
  };

  handleSubmitRadioShippingAddress = async type => {
    if (type === 'change') {
      const { radioShippingAddress } = this.state;
      const { userAddress } = this.props;
      const newShippingAddress = _.filter(
        userAddress,
        (address, index) => index === radioShippingAddress
      );
      await this.setState(prevSt => ({
        ...prevSt,
        shippingAddress: { ...newShippingAddress[0] },
        switchShippingAddress: false
      }));
    } else {
      const { userAddress } = this.props;
      const radioShippingAddressSelected = _.findIndex(
        userAddress,
        add => add.isDefault === 'Y'
      );
      this.setState(prevSt => ({
        ...prevSt,
        radioShippingAddress: radioShippingAddressSelected,
        switchShippingAddress: false
      }));
    }
  };

  handleSubmitRadioTaxInvoiceAddress = type => {
    if (type === 'change') {
      const { radioTaxInvoiceAddress } = this.state;
      const { userTaxInvoiceAddress } = this.props;
      const newTaxInvoiceAddress = _.filter(
        userTaxInvoiceAddress,
        (address, index) => index === radioTaxInvoiceAddress
      );
      this.setState(prevSt => ({
        ...prevSt,
        taxInvoiceAddress: { ...newTaxInvoiceAddress[0] },
        switchTaxInvoiceAddress: false
      }));
    } else {
      const { userTaxInvoiceAddress } = this.props;
      const radioShippingAddressSelected = _.findIndex(
        userTaxInvoiceAddress,
        add => add.isDefault === 'Y'
      );
      this.setState(prevSt => ({
        ...prevSt,
        radioTaxInvoiceAddress: radioShippingAddressSelected,
        switchTaxInvoiceAddress: false
      }));
    }
  };

  handlePayMentMethodChange = async value => {
    const { OpenDialogSfPlusAccountNotLinked, FirebaseSfPlusUser } = this.props;
    if (value === 1) {
      await FirebaseSfPlusUser();
      const { isSfPlusLinked } = await this.props;
      if (!isSfPlusLinked) OpenDialogSfPlusAccountNotLinked();
    }
    this.setState({ paymentMethodSelected: value, btnPurchaseState: true });
  };

  handleTaxInvoiceCheckbox = async () => {
    await this.setState(prevState => ({
      ...prevState,
      TaxInvoiceCheckbox: !prevState.TaxInvoiceCheckbox
    }));

    const { TaxInvoiceCheckbox } = await this.state;

    if (TaxInvoiceCheckbox) {
      const { GetTaxAddress, OpenDialogCreateTaxAddress, isAuthenticated } = this.props;
      if (!isAuthenticated) {
        OpenDialogCreateTaxAddress();
        return;
      }
      await GetTaxAddress();
      const { userTaxInvoiceAddress } = await this.props;
      if (userTaxInvoiceAddress && userTaxInvoiceAddress.length === 0) {
        OpenDialogCreateTaxAddress();
      }
    }
  };

  handlePurchaseOrder = async () => {
    const {
      TaxInvoiceCheckbox,
      paymentMethodSelected,
      shippingCost,
      emailShipping,
      shippingAddress,
      subTotal,
      dataShippingBranch,
      radioShippingSelected
    } = this.state;
    const {
      userAddress,
      OpenDialogCreateAddress,
      userTaxInvoiceAddress,
      OpenDialogCreateTaxAddress,
      isSfPlusLinked,
      OpenDialogSfPlusAccountNotLinked,
      chackBalanceData,
      OpenDialogSfPlusBalance,
      OpenDialogCheckOutPolicy,
      OpenDialogPhoneNumber,
      OpenDialogFurtherInformation,
      isAuthenticated
    } = this.props;

    const dataShipping = radioShippingSelected == SHIPPING_SELECT.BRANCH ? dataShippingBranch : shippingAddress;

    ////// handle address info first
    if (!dataShippingBranch.isValid && radioShippingSelected == SHIPPING_SELECT.BRANCH) {
      const { $ } = window;
      $('html, body').animate({
        scrollTop: $("#input-select-branch").offset().top - window.innerHeight / 2
      }, 'fast', () => {
        let check = dataShippingBranch?.errors?.includes(SHIPPING_SELECT.BRANCH);
        check == null || check
          ? $("#input-select-branch").focus().nextAll(".error").text("Invalid data.").show()
          : $("#input-telephone").focus().nextAll(".error").text("Invalid data.").show();
      });
    } else if ((!userAddress || (userAddress.length === 0 && !emailShipping)) && radioShippingSelected != SHIPPING_SELECT.BRANCH) {
      OpenDialogCreateAddress();
    } else if ((!isAuthenticated && !dataShipping.email) || !dataShipping.phoneNumber || (!dataShipping.name && !dataShipping.lastName)) {
      OpenDialogFurtherInformation();
    } else {
      if (
        TaxInvoiceCheckbox &&
        userTaxInvoiceAddress &&
        userTaxInvoiceAddress.length === 0
      ) {
        OpenDialogCreateTaxAddress();
      } else {
        if (paymentMethodSelected === 0) {
          OpenDialogCheckOutPolicy(PAYMENT_TYPE.CREDIT_CARD);
        } else if (paymentMethodSelected === 1) {
          if (!isSfPlusLinked) {
            OpenDialogSfPlusAccountNotLinked();
          } else {
            //////////need check balance with total
            const total = parseInt(subTotal) + parseInt(shippingCost);
            if (parseInt(chackBalanceData.strBalance) < total) {
              OpenDialogSfPlusBalance();
            } else {
              OpenDialogCheckOutPolicy(PAYMENT_TYPE.SFPLUS);
            }
          }
        } else if (paymentMethodSelected === 2) {
          OpenDialogCheckOutPolicy(PAYMENT_TYPE.THAI_QR);
        }
      }
    }
  };

  handleShowKbankPayment = (show) => this.setState({ showKbankpaymentDialog: show })
  handleAfterAcceptPolicy = async () => {
    const { paymentMethodSelected } = this.state;
    const {
      doAfterAcceptPolicy,
      OpenDialogSfPlusValidatePin,
      CreditCardOrdering,
      defaultCreditCardPaymentGatway,
      OpenDialogThaiQR,
      ThaiQROrdering
    } = this.props;
    if (
      paymentMethodSelected === 0 &&
      doAfterAcceptPolicy === PAYMENT_TYPE.CREDIT_CARD
    ) {
      await CreditCardOrdering(this.handleGetAddressShipping());
      const {
        orderingData,
        kBankData,
        GetKPaymentHash,
        Get2c2pHash
      } = await this.props;
      const { INVMERCHANT, AMOUNT2 } = kBankData;

      if (orderingData?.vistatransno) {
        ////// value from transaction
        const MOD_INVMERCHANT = `${BANK_INVOICE}${pad(INVMERCHANT, 11)}`;
        if (defaultCreditCardPaymentGatway === 'K Payment') {
          // await this.setState(prevSt => ({
          //   ...prevSt,
          //   showKbankpaymentDialog: true
          // }));

          const _CHECKSUM = await GetKPaymentHash(
            AMOUNT2,
            MOD_INVMERCHANT
          ).then(_CHECKSUM => _CHECKSUM);

          ////// modify k-bank gateway form
          document.getElementById('AMOUNT2').value = AMOUNT2;
          document.getElementById('INVMERCHANT').value = MOD_INVMERCHANT;
          document.getElementById('CHECKSUM').value = _CHECKSUM;
        } else if (defaultCreditCardPaymentGatway === '2C2P') {
          let AMOUNT = AMOUNT2.toString().padStart(12, '0');
          const HASH_VALUE = await Get2c2pHash(AMOUNT, MOD_INVMERCHANT).then(
            HASH_VALUE => HASH_VALUE
          );

          ////// modify 2C2P gateway form
          document.getElementById('amount').value = AMOUNT;
          document.getElementById('order_id').value = MOD_INVMERCHANT;
          document.getElementById('hash_value').value = HASH_VALUE;
        }

        document.forms['postform'].submit();
      }
    } else if (
      paymentMethodSelected === 1 &&
      doAfterAcceptPolicy === PAYMENT_TYPE.SFPLUS
    ) {
      OpenDialogSfPlusValidatePin();
    } else if (
      paymentMethodSelected === 2 &&
      doAfterAcceptPolicy === PAYMENT_TYPE.THAI_QR
    ) {
      await ThaiQROrdering(this.handleGetAddressShipping());
      const { thaiQRorderingData } = await this.props;

      if (thaiQRorderingData?.vistatransno) {
        OpenDialogThaiQR();
      }
    }
  };

  handleGetAddressShipping = () => {
    const {
      shippingAddress,
      shippingCost,
      TaxInvoiceCheckbox,
      taxInvoiceAddress,
      dataShippingBranch,
      radioShippingSelected
    } = this.state;
    const {
      name,
      lastName,
      phoneNumber,
      address,
      district,
      subDistrict,
      province,
      zipCode,
      branchId,
      email
    } = radioShippingSelected == SHIPPING_SELECT.POST_OFFICE ? shippingAddress : dataShippingBranch;
    return {
      name,
      lastName,
      phoneNumber,
      address,
      district,
      subDistrict,
      province,
      zipCode,
      shippingCost,
      TaxInvoiceCheckbox,
      taxInvoiceAddress,
      deliveryType: firstUpperCase(radioShippingSelected),
      branchId,
      email
    };
  }

  handleShippingCost = async () => {
    const { freeShipping, checkOutData, emailShipping, promotionCartSelected, subTotal, promotiontotal, shippingAddress } = this.state;
    if (freeShipping || emailShipping) {
      this.setState({ shippingCost: 0 });
      return;
    }
    const { GetShippingCost } = this.props;
    const { province, district, zipCode } = shippingAddress;

    const address = { province, district, zipCode }
    if (checkOutData) {
      const shipping = await GetShippingCost(
        subTotal - promotiontotal,
        checkOutData
          .concat(promotionCartSelected)
          .map((item, index) => ({ itemId: `${item.itemId}-${index}`, qty: item.qty, weight: item.weight }))  /* items */,
        address,
      );
      this.setState({ shippingCost: shipping.shippingCost });
    }
  };

  handleSubtotal = (checkOutData, promotionCartSelected = []) => {
    const initialValue = 0;
    const total =
      checkOutData &&
      checkOutData.reduce((accumulator, currentValue) => {
        const totalPricePerItem = currentValue.qty * currentValue.price;
        return accumulator + totalPricePerItem;
      }, initialValue);
    const totalPromotion = promotionCartSelected.reduce((accumulator, currentValue) => {
      const totalPricePerItem = currentValue.qty * currentValue.price;
      return accumulator + totalPricePerItem;
    }, initialValue)
    return total + totalPromotion;
  };

  handleChangePhoneNumber = phoneNumber => {
    const { shippingAddress } = this.state;
    this.setState({
      shippingAddress: {
        ...shippingAddress,
        phoneNumber
      }
    });
    this.handlePurchaseOrder();
  };

  handleChangeFurtherInformationAddress = async values => {
    const { radioShippingSelected } = this.state;
    const prop = radioShippingSelected == SHIPPING_SELECT.BRANCH ? "dataShippingBranch" : "shippingAddress";
    await this.setState({
      [prop]: {
        ...this.state[prop],
        ...values
      }
    });
    this.handlePurchaseOrder();
  };

  handleCancelCreateTaxAddress = async () => {
    await this.setState(prevSt => ({
      ...prevSt,
      TaxInvoiceCheckbox: false
    }));
  };

  handleChangeTaxAddress = async values => {
    await this.setState({
      taxInvoiceAddress: {
        ...this.state.taxInvoiceAddress,
        ...values
      }
    });
  };

  handleChangeSelectShipping = async name => {
    await this.setState({ freeShipping: name == SHIPPING_SELECT.BRANCH, radioShippingSelected: name });
  }

  handleChangeDataShippingBranch = async data => {
    return await this.setState({ dataShippingBranch: { ...this.state.dataShippingBranch, [data.name]: data.value } });
  }

  render() {
    const {
      shippingAddress,
      switchShippingAddress,
      radioShippingAddress,
      shippingCost,
      taxInvoiceAddress,
      switchTaxInvoiceAddress,
      radioTaxInvoiceAddress,
      TaxInvoiceCheckbox,
      paymentMethod,
      paymentMethodSelected,
      btnPurchaseState,
      subTotal,
      checkOutData,
      colorselected,
      sizeselected,
      promotiontotal,
      promotionCartSelected,
      emailShipping,
      radioShippingSelected,
      dataShippingBranch
    } = this.state;

    const {
      wording,
      basenameURL,

      userAddress,
      OpenDialogCreateAddress,

      userTaxInvoiceAddressFetching,
      userTaxInvoiceAddress,
      OpenDialogCreateTaxAddress,

      sfPlusChecked,
      firebaseSfPlusUser,
      chackBalanceData,
      firebaseAuth,
      isAuthenticated,

      dialogBalance,
      CloseDialogSfPlusBalance,

      dialogAccountNotLinked,
      CloseDialogSfPlusAccountNotLinked,

      dialogValidatePin,
      validatePinError,
      SFPlusValidatePin,
      CloseDialogSfPlusValidatePin,

      orderingFetching,
      history,

      defaultCreditCardPaymentGatway,
      paymentType_sfPlus,
      paymentType_qrCode,

      dialogThaiQR,
      CloseDialogThaiQR,

      promotion
    } = this.props;

    const deliveryAddress = radioShippingSelected == SHIPPING_SELECT.POST_OFFICE ? shippingAddress : dataShippingBranch;

    const deliveryAddressAndShippingCost = {
      ...deliveryAddress,
      shippingCost,
      TaxInvoiceCheckbox,
      taxInvoiceAddress,
      deliveryType: firstUpperCase(radioShippingSelected)
    };

    if (!checkOutData || checkOutData.length === 0) {
      return <CheckoutEmpty />;
    }

    return (
      <>
        {/* <KPayment
          show={this.state.showKbankpaymentDialog}
          handleShow={this.handleShowKbankPayment}
          debug={true} /> */}

        <DialogCreateAddress id="create-address" />

        <DialogCreateTaxAddress applyFormChange={this.handleChangeTaxAddress} cancelForm={this.handleCancelCreateTaxAddress} id="create-tax-address" />

        <DialogSFPlusInfo
          id="account-not-linked"
          open={dialogAccountNotLinked}
          title={wording.checkoutPage.dialogSFPlusInfo.title}
          message={wording.checkoutPage.dialogSFPlusInfo.linked}
          close={wording.checkoutPage.dialogSFPlusInfo.close}
          closeDialog={CloseDialogSfPlusAccountNotLinked}
        />

        <DialogSFPlusInfo
          id="balance"
          open={dialogBalance}
          title={wording.checkoutPage.dialogSFPlusInfo.title}
          message={wording.checkoutPage.dialogSFPlusInfo.balance}
          close={wording.checkoutPage.dialogSFPlusInfo.close}
          closeDialog={CloseDialogSfPlusBalance}
        />

        <DialogPolicy onAcceptPolicy={this.handleAfterAcceptPolicy} />

        <DialogSfPlusVlidatePin
          id="validatepin"
          open={dialogValidatePin}
          error={validatePinError}
          submitDialog={SFPlusValidatePin}
          closeDialog={CloseDialogSfPlusValidatePin}
          deliveryAddressAndShippingCost={deliveryAddressAndShippingCost}
        />

        <DialogPhoneNumber applyFormChange={this.handleChangePhoneNumber} />
        <DialogFurtherInformation emailShipping={emailShipping} dataShipping={this.state[radioShippingSelected == SHIPPING_SELECT.BRANCH ? "dataShippingBranch" : "shippingAddress"]} applyFormChange={this.handleChangeFurtherInformationAddress} shipping={radioShippingSelected} />

        <DialogThaiQR
          id="ThaiQR"
          open={dialogThaiQR}
          closeDialog={CloseDialogThaiQR}
        />

        {orderingFetching && <LayoutPreloadTransparent />}

        <CheckoutTitle />

        <section className="section-wrap-small shopping-cart">
          <div className="container relative">
            <div className="order row">
              <div className="col-md-12">
                <div className="mt-10">
                  <h2 className="heading relative heading-small uppercase bottom-line style-2 left-align mb-30">
                    {wording.checkoutPage.checkout.purchaseOrder}
                  </h2>
                </div>
                <div className="table-wrap">
                  <table className="shop_table cart table">
                    <PurchaseOrderTableHeader />
                    <tbody>
                      {checkOutData &&
                        checkOutData.map((item, index) => {
                          return (
                            <tr
                              key={`checkout-${item.itemId}-${index}`}
                              className="cart_item">
                              <td className="product-thumbnail">
                                <Link
                                  to={`/product/${item.itemName
                                    .split(' ')
                                    .join('-')}`}>
                                  <img
                                    src={`${API.PRODUCT_IMG_URL}${item.cartItemImage}`}
                                    alt={item.cartItemImage}
                                  />
                                </Link>
                              </td>

                              <td className="product-name">
                                <Link
                                  to={`/${item.type}/${item.itemName
                                    .split(' ')
                                    .join('-')}`}
                                  className="white">
                                  {item.itemName}
                                </Link>
                                <ul>
                                  {item.sizeName && item.sizeName !== 'N' && (
                                    <li>{`${wording.checkoutPage.checkout.size}: ${item.sizeName}`}</li>
                                  )}

                                  {item.rgbColor && item.rgbColor !== null && (
                                    <li>
                                      <div
                                        style={{ display: 'flex' }}
                                        className="color-select clearfix">
                                        <span
                                          style={{
                                            marginTop: 0,
                                            marginRight: 4
                                          }}>
                                          {`${wording.checkoutPage.checkout.color}:`}
                                        </span>
                                        <ul className="color-swatches clearfix">
                                          <li>
                                            <a
                                              className="pointer"
                                              style={{
                                                backgroundColor: item.rgbColor,
                                                width: 18,
                                                height: 18
                                              }}
                                            />
                                          </li>
                                        </ul>
                                      </div>
                                    </li>
                                  )}
                                  {item.promotionName && (
                                    <li>
                                      {`${wording.cartPage.avaliableOrder.promotion}: `}
                                      {item.promotionName}
                                    </li>
                                  )}
                                </ul>
                              </td>

                              <td className="product-price">
                                {item.promotionPrice > 0 && item.promotionPrice < item.price ? (
                                  <>
                                    <del>
                                      <span className='amount white'>{`${CURRENCY.B}${formatMoney(item.price)}`}</span>
                                    </del>
                                    <span
                                      className='amount white pl-10'>
                                      {`${CURRENCY.B}${formatMoney(item.promotionPrice)}`}
                                    </span>
                                  </>
                                ) : (
                                  <span className='amount white'>{`${CURRENCY.B}${formatMoney(item.price)}`}</span>
                                )}
                              </td>

                              <td className="product-price">
                                <span className="amount white">{item.qty}</span>
                              </td>

                              <td className="product-subtotal">
                                <span className="amount white">
                                  {`${CURRENCY.B}${formatMoney(item.qty * (
                                    item.promotionPrice > 0 && item.promotionPrice < item.price
                                      ? item.promotionPrice
                                      : item.price
                                  ))}`
                                  }
                                </span>
                              </td>
                            </tr>
                          );
                        })}

                      {(promotionCartSelected?.length > 0 && promotion.responcePromotionitem.map((items, indexs) => {
                        return (
                          <Fragment key={indexs}>
                            {items.item?.map((model, indexmodel) => {
                              var proCartSelected = promotionCartSelected.find(pro => pro.id == `${items.promotionid}-${model.modelId}`);
                              return (
                                <Fragment key={indexmodel}>
                                  {proCartSelected && (

                                    <tr
                                      key={`checkout-${model.modelId}-${indexmodel}`}
                                      className="cart_item">
                                      <td className="product-thumbnail">
                                        {model.item.map((item, index) => {
                                          return (
                                            <Fragment key={index}>
                                              <Link
                                                to={`/product/${model.modelName.split(" ").join("-")}`}
                                              >
                                                {colorselected.includes(model.modelId + item.rgbColor) && sizeselected.includes(model.modelId + item.sizeName) ? (
                                                  <img
                                                    style={{ minHeight: 126.67 }}
                                                    src={`${API.PRODUCT_IMG_URL}${item.cartItemImage}`}
                                                    alt={item.cartItemImage}
                                                  />
                                                ) : (
                                                  <>
                                                    {item.rgbColor == null && (
                                                      <img
                                                        style={{ minHeight: 126.67 }}
                                                        src={`${API.PRODUCT_IMG_URL}${model.item[0].cartItemImage}`}
                                                        alt={model.item[0].cartItemImage}
                                                      />
                                                    )}
                                                  </>
                                                )}
                                              </Link>
                                            </Fragment>
                                          )
                                        })}
                                      </td>
                                      <td className="product-name">
                                        <Link
                                          to={`/product/${model.modelName
                                            .split(' ')
                                            .join('-')}`}
                                          className="white">
                                          {model.modelName}
                                        </Link>
                                        <ul>
                                          {model.item[0].sizeName && model.item[0].sizeName !== 'N' && (
                                            <li>{`${wording.checkoutPage.checkout.size}: ${sizeselected.filter(size => size.slice(0, model.modelId.length) == model.modelId).map(size => size.replace(model.modelId, ""))}`}</li>
                                          )}

                                          {model.item[0].rgbColor && model.item[0].rgbColor !== null && (
                                            <li>
                                              <div
                                                style={{ display: 'flex' }}
                                                className="color-select clearfix">
                                                <span
                                                  style={{
                                                    marginTop: 0,
                                                    marginRight: 4
                                                  }}>
                                                  {`${wording.checkoutPage.checkout.color}:`}
                                                </span>
                                                <ul className="color-swatches clearfix">
                                                  <li>
                                                    <a
                                                      className="pointer"
                                                      style={{
                                                        backgroundColor: colorselected.filter(size => size.slice(0, model.modelId.length) == model.modelId).map(size => size.replace(model.modelId, "")),
                                                        width: 18,
                                                        height: 18
                                                      }}
                                                    />
                                                  </li>
                                                </ul>
                                              </div>
                                            </li>
                                          )}
                                          {model.name && (
                                            <li>
                                              {`${wording.cartPage.avaliableOrder.promotion}: `}
                                              {model.name}
                                            </li>
                                          )}
                                        </ul>
                                      </td>
                                      <td className="product-price">
                                        {model.promotionPrice > 0 && model.promotionPrice < model.price ? (
                                          <>
                                            <del>
                                              <span className='amount white'>{`${CURRENCY.B}${formatMoney(model.price)}`}</span>
                                            </del>
                                            <span
                                              className='amount white pl-10'>
                                              {`${CURRENCY.B}${formatMoney(model.promotionPrice)}`}
                                            </span>
                                          </>
                                        ) : (
                                          <span className='amount white'>{`${CURRENCY.B}${formatMoney(model.price)}`}</span>
                                        )}
                                      </td>

                                      <td className="product-price">
                                        <span className="amount white">{proCartSelected?.qty || items.amount}</span>
                                      </td>

                                      <td className="product-subtotal">
                                        <span className="amount white">
                                          {`${CURRENCY.B}${formatMoney(items.amount * model.promotionPrice)}`
                                          }
                                        </span>
                                      </td>
                                    </tr>
                                  )}
                                </Fragment>
                              )
                            })}
                          </Fragment>
                        )
                      })
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <SelectShipping
              onChangeSelected={this.handleChangeSelectShipping}
              shippingSelected={radioShippingSelected}
              onChangeDataShippingBranch={this.handleChangeDataShippingBranch}
              dataShippingBranch={dataShippingBranch}
            />

            {
              radioShippingSelected == SHIPPING_SELECT.POST_OFFICE && (
                <>
                  {
                    ((emailShipping && firebaseAuth?.email) || !emailShipping) && (

                      <div className="address row">
                        <div className="col-md-12">
                          <div className="mt-60">
                            <h2 className="heading relative heading-small uppercase bottom-line style-2 left-align mb-30">
                              {
                                wording.checkoutPage[
                                  emailShipping ? 'EmailAddress' : 'shippingAddress'
                                ].title
                              }
                            </h2>
                          </div>
                          {emailShipping ? (
                            <>
                              <div className="billing-address-warpper mb-0">
                                <div className="billing-user-detail white">
                                  <span>{firebaseAuth && firebaseAuth.email}</span>
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                              {!switchShippingAddress &&
                                userAddress &&
                                userAddress.length > 0 && (
                                  <div className="billing-address-warpper mb-0">
                                    <div className="billing-user-detail white">
                                      <span>{`${shippingAddress.name} ${shippingAddress.lastName} ${shippingAddress.phoneNumber}`}</span>
                                      <span className="billing-user-address white">
                                        {` ${shippingAddress.address}, ${(!shippingAddress || !shippingAddress.subDistrict ? "" : `${shippingAddress.subDistrict}, `)}${shippingAddress.district}, ${shippingAddress.province}, ${shippingAddress.zipCode}`}
                                      </span>
                                    </div>
                                    {shippingAddress.isDefault === 'Y' && isAuthenticated && (
                                      <div>
                                        {wording.checkoutPage.shippingAddress.default}
                                      </div>
                                    )}
                                    <div
                                      className="btn-change-address pointer"
                                      onClick={() => {
                                        if (isAuthenticated)
                                          this.setState({ switchShippingAddress: true })
                                        else
                                          OpenDialogCreateAddress()
                                      }}>
                                      {wording.checkoutPage.shippingAddress.change}
                                    </div>
                                  </div>
                                )}

                              {switchShippingAddress &&
                                userAddress &&
                                userAddress.length > 0 && (
                                  <div className="row">
                                    <div className="col-sm-12 mb-20">
                                      <a
                                        className="btn btn-md btn-light right"
                                        style={{ marginRight: 10 }}
                                        onClick={() =>
                                          history.push(`${basenameURL}/user/address`)
                                        }>
                                        {
                                          wording.checkoutPage.shippingAddress
                                            .manageAddress
                                        }
                                      </a>
                                      <a
                                        className="btn btn-md btn-light right"
                                        style={{ marginRight: 10 }}
                                        onClick={OpenDialogCreateAddress}>
                                        {wording.checkoutPage.shippingAddress.add}
                                      </a>
                                    </div>
                                    <div style={{ paddingLeft: 20 }}>
                                      <ul className="radio-buttons">
                                        {userAddress &&
                                          userAddress.map((address, index) => {
                                            return (
                                              <li key={`shipping-address-${index}`}>
                                                <input
                                                  id={`radio${index}`}
                                                  name={`radio${index}`}
                                                  type="radio"
                                                  className="input-radio"
                                                  value={index}
                                                  checked={
                                                    radioShippingAddress === index
                                                      ? true
                                                      : false
                                                  }
                                                  onChange={() =>
                                                    this.handleRadioAddressChange(
                                                      'radioShippingAddress',
                                                      index
                                                    )
                                                  }
                                                />
                                                <label htmlFor={`radio${index}`}>
                                                  <span>{`${address.name} ${address.lastName} ${address.phoneNumber}`}</span>
                                                  <span className="billing-user-address white">
                                                    {console.log(address)}
                                                    {` ${address.address}, ${(!address || !address.subDistrict ? "" : `${address.subDistrict}, `)}${address.district}, ${address.province}, ${address.zipCode}`}
                                                  </span>
                                                  {address.isDefault === 'Y' && (
                                                    <span>{`(${wording.checkoutPage.shippingAddress.default})`}</span>
                                                  )}
                                                </label>
                                              </li>
                                            );
                                          })}
                                      </ul>
                                    </div>
                                    <div className="col-sm-12 mt-20">
                                      <a
                                        className="btn btn-md btn-dark"
                                        style={{ marginRight: 10 }}
                                        onClick={() =>
                                          this.handleSubmitRadioShippingAddress('change')
                                        }>
                                        {wording.checkoutPage.shippingAddress.ok}
                                      </a>
                                      <a
                                        className="btn btn-md btn-light"
                                        style={{ marginRight: 10 }}
                                        onClick={() =>
                                          this.handleSubmitRadioShippingAddress('cancel')
                                        }>
                                        {wording.checkoutPage.shippingAddress.cancel}
                                      </a>
                                    </div>
                                  </div>
                                )}

                              {userAddress && userAddress.length === 0 && (
                                <button
                                  className="btn btn-md btn-light"
                                  onClick={OpenDialogCreateAddress}>
                                  {wording.checkoutPage.shippingAddress.add}
                                </button>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    )
                  }
                </>
              )
            }

            {TaxInvoiceCheckbox && (
              <div className="tax-address row">
                <div className="col-md-12">
                  <div className="mt-60">
                    <h2 className="heading relative heading-small uppercase bottom-line style-2 left-align mb-30">
                      {wording.checkoutPage.taxInvoiceAddress.title}
                    </h2>
                  </div>
                  {userTaxInvoiceAddressFetching && (
                    <h2>{wording.checkoutPage.checkout.checking}</h2>
                  )}
                  {!switchTaxInvoiceAddress &&
                    ((userTaxInvoiceAddress &&
                      userTaxInvoiceAddress.length > 0) || (!isAuthenticated && taxInvoiceAddress.name)) && (
                      <div className="billing-address-warpper mb-0">
                        {console.log(taxInvoiceAddress)}
                        <div className="billing-user-detail white">
                          <span>{`${taxInvoiceAddress.name} ${taxInvoiceAddress.lastName} ${taxInvoiceAddress.taxId}`}</span>
                          <span className="billing-user-address white">
                            {` ${taxInvoiceAddress.address}, ${(!taxInvoiceAddress || !taxInvoiceAddress.subDistrict ? "" : `${taxInvoiceAddress.subDistrict}, `)} ${taxInvoiceAddress.district}, ${taxInvoiceAddress.province}, ${taxInvoiceAddress.zipCode}`}
                          </span>
                          <br />
                          <span>{`${taxInvoiceAddress.phoneNumber} ${taxInvoiceAddress.email}`}</span>
                        </div>
                        <div>
                          {wording.checkoutPage.taxInvoiceAddress.default}
                        </div>
                        <div
                          id="btn-change-tax-address"
                          className="btn-change-address pointer"
                          onClick={() =>
                            this.setState({ switchTaxInvoiceAddress: true })
                          }>
                          {wording.checkoutPage.taxInvoiceAddress.change}
                        </div>
                      </div>
                    )}

                  {switchTaxInvoiceAddress &&
                    userTaxInvoiceAddress &&
                    userTaxInvoiceAddress.length > 0 && (
                      <div className="row">
                        <div className="col-sm-12 mb-20">
                          <a
                            className="btn btn-md btn-light right"
                            style={{ marginRight: 10 }}
                            onClick={() =>
                              history.push(`${basenameURL}/user/address`)
                            }>
                            {
                              wording.checkoutPage.taxInvoiceAddress
                                .manageAddress
                            }
                          </a>
                          <a
                            className="btn btn-md btn-light right"
                            style={{ marginRight: 10 }}
                            onClick={OpenDialogCreateTaxAddress}>
                            {wording.checkoutPage.taxInvoiceAddress.add}
                          </a>
                        </div>
                        <div style={{ paddingLeft: 20 }}>
                          <ul className="radio-buttons">
                            {userTaxInvoiceAddress &&
                              userTaxInvoiceAddress.map((address, index) => {
                                return (
                                  <li key={`invoice-address-${index}`}>
                                    <input
                                      id={`radio${index}`}
                                      name={`radio${index}`}
                                      type="radio"
                                      className="input-radio"
                                      value={index}
                                      checked={
                                        radioTaxInvoiceAddress === index
                                          ? true
                                          : false
                                      }
                                      onChange={() =>
                                        this.handleRadioAddressChange(
                                          'radioTaxInvoiceAddress',
                                          index
                                        )
                                      }
                                    />
                                    <label htmlFor={`radio${index}`}>
                                      <span>
                                        {`${address.name} ${address.lastName} ${address.taxId} ${address.address}, ${(!address || !address.subDistrict ? "" : `${address.subDistrict}, `)} ${address.district}, ${address.province}, ${address.zipCode}`}
                                        {address.isDefault === 'Y' && (
                                          <span className="pl-30">{`(${wording.checkoutPage.taxInvoiceAddress.default})`}</span>
                                        )}
                                      </span>
                                      <br />
                                      <span style={{ paddingLeft: 28 }}>
                                        {` ${address.phoneNumber} ${address.email}`}
                                      </span>
                                    </label>
                                  </li>
                                );
                              })}
                          </ul>
                        </div>
                        <div className="col-sm-12 mt-20">
                          <a
                            className="btn btn-md btn-dark"
                            style={{ marginRight: 10 }}
                            onClick={() =>
                              this.handleSubmitRadioTaxInvoiceAddress('change')
                            }>
                            {wording.checkoutPage.taxInvoiceAddress.ok}
                          </a>
                          <a
                            className="btn btn-md btn-light"
                            style={{ marginRight: 10 }}
                            onClick={() =>
                              this.handleSubmitRadioTaxInvoiceAddress('cancel')
                            }>
                            {wording.checkoutPage.taxInvoiceAddress.cancel}
                          </a>
                        </div>
                      </div>
                    )}

                  {(userTaxInvoiceAddress && userTaxInvoiceAddress.length === 0) || (!isAuthenticated && !taxInvoiceAddress.name) && (
                    <button
                      className="btn btn-md btn-light"
                      onClick={OpenDialogCreateTaxAddress}>
                      {wording.checkoutPage.taxInvoiceAddress.add}
                    </button>
                  )}
                </div>
              </div>
            )}

            {subTotal - promotiontotal + shippingCost > 0 && (
              <div className="payment row">
                <div className="col-md-12">
                  <div className="mt-60">
                    <h2 className="heading relative heading-small uppercase bottom-line style-2 left-align mb-30">
                      {wording.checkoutPage.paymentMethod.title}
                    </h2>
                  </div>

                  <div className="payment-menu">
                    <div className="tab-menu mb-10">
                      {paymentMethod.map((method, index) => {
                        if (
                          (method.id === 'credit-card' &&
                            defaultCreditCardPaymentGatway) ||
                          (method.id === 'sf-plus' && paymentType_sfPlus) ||
                          (method.id === 'qrcode' && paymentType_qrCode)
                        ) {
                          return (
                            <a
                              key={method.id}
                              href={`#tab-${method.id}`}
                              data-toggle="tab"
                              className={classNames(
                                'btn btn-md mt-10 mr-10',
                                {
                                  'btn-light': paymentMethodSelected !== index
                                },
                                { 'btn-dark': paymentMethodSelected === index }
                              )}
                              onClick={() =>
                                this.handlePayMentMethodChange(index)
                              }>
                              {method.id === 'credit-card'
                                ? wording.checkoutPage.paymentMethod
                                  .creditDebitCard
                                : null}
                              {method.id === 'sf-plus'
                                ? wording.checkoutPage.paymentMethod.sfPlus
                                : null}
                              {method.id === 'qrcode'
                                ? wording.checkoutPage.paymentMethod.qrCode
                                : null}
                            </a>
                          );
                        }
                      })}
                    </div>

                    <div className="tab-content">
                      <div
                        id="tab-credit-card"
                        className={classNames('tab-pane fade', {
                          'active in': paymentMethodSelected === 0
                        })}>
                        <div className="row">
                          <div className="col-md-12">
                            {defaultCreditCardPaymentGatway === 'K Payment' ? (
                              <form
                                id="postform"
                                method="post"
                                action={KBANK.BANK_HOST}>
                                <input
                                  type="hidden"
                                  id="MERCHANT2"
                                  name="MERCHANT2"
                                  value={KBANK.MERCHANT2}
                                />
                                <input
                                  type="hidden"
                                  id="TERM2"
                                  name="TERM2"
                                  value={KBANK.TERM2}
                                />
                                <input
                                  type="hidden"
                                  id="AMOUNT2"
                                  name="AMOUNT2"
                                  value={KBANK.AMOUNT2}
                                />
                                <input
                                  type="hidden"
                                  id="URL2"
                                  name="URL2"
                                  value={KBANK.URL2}
                                />
                                <input
                                  type="hidden"
                                  id="RESPURL"
                                  name="RESPURL"
                                  value=""
                                />
                                <input
                                  type="hidden"
                                  id="IPCUST2"
                                  name="IPCUST2"
                                  value={KBANK.IPCUST2}
                                />
                                <input
                                  type="hidden"
                                  id="DETAIL2"
                                  name="DETAIL2"
                                  value={KBANK.DETAIL2}
                                />
                                <input
                                  type="hidden"
                                  id="INVMERCHANT"
                                  name="INVMERCHANT"
                                  value={KBANK.INVMERCHANT}
                                />
                                <input
                                  type="hidden"
                                  id="FILLSPACE"
                                  name="FILLSPACE"
                                  value={KBANK.FILLSPACE}
                                />
                                <input
                                  type="hidden"
                                  id="CHECKSUM"
                                  name="CHECKSUM"
                                  value={KBANK.CHECKSUM}
                                />
                              </form>
                            ) : (
                              <form
                                id="postform"
                                method="post"
                                action={`${CONST_2C2P.PAYMENT_URL}`}>
                                <input
                                  type="hidden"
                                  id="version"
                                  name="version"
                                  value={`${CONST_2C2P.VERSION}`}
                                />
                                <input
                                  type="hidden"
                                  id="merchant_id"
                                  name="merchant_id"
                                  value={`${CONST_2C2P.MERCHANT_ID}`}
                                />
                                <input
                                  type="hidden"
                                  id="currency"
                                  name="currency"
                                  value={`${CONST_2C2P.CURRENCY}`}
                                />
                                <input
                                  type="hidden"
                                  id="result_url_1"
                                  name="result_url_1"
                                  value={`${CONST_2C2P.RESULT_URL_1}`}
                                />
                                <input
                                  type="hidden"
                                  id="payment_option"
                                  name="payment_option"
                                  value={`${CONST_2C2P.PAYMENT_OPTION}`}
                                />
                                <input
                                  type="hidden"
                                  id="payment_description"
                                  name="payment_description"
                                  value={`${CONST_2C2P.PAYMENT_DESCRIPTION}`}
                                />
                                <input
                                  type="hidden"
                                  id="hash_value"
                                  name="hash_value"
                                  value={`${CONST_2C2P.HASH_VALUE}`}
                                />
                                <input
                                  type="hidden"
                                  id="order_id"
                                  name="order_id"
                                  value={`${CONST_2C2P.ORDER_ID}`}
                                />
                                <input
                                  type="hidden"
                                  id="amount"
                                  name="amount"
                                  value={`${CONST_2C2P.AMOUNT}`}
                                />
                              </form>
                            )}
                          </div>
                        </div>
                      </div>

                      {paymentMethodSelected === 1 && !sfPlusChecked && (
                        <h2>{wording.checkoutPage.checkout.checking}</h2>
                      )}
                      {paymentMethodSelected === 1 && sfPlusChecked && (
                        <div
                          id="tab-sf-plus"
                          className={classNames('tab-pane fade', {
                            'active in': paymentMethodSelected === 1
                          })}>
                          <div className="row">
                            <div className="col-md-12">
                              <div className="payment-logo-warpper">
                                <div className="payment-img payment-sf-plus ml-20" />
                                {firebaseSfPlusUser && (
                                  <div className="payment-sf-plus-info mt-10 ml-30">
                                    <span>{`${wording.checkoutPage.paymentMethod
                                      .sfPlusBalance
                                      } (${CURRENCY.B}${formatMoney(
                                        parseInt(chackBalanceData.strBalance)
                                      )})`}</span>
                                    <br />
                                    <span>
                                      {
                                        wording.checkoutPage.paymentMethod
                                          .sfPlusWallet
                                      }
                                    </span>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="table-total row">
              <div className="col-xs-12 col-xs-offset-0 col-md-4 col-md-offset-8">
                <div className="ecommerce-checkout-review-order">
                  <table className="table shop_table ecommerce-checkout-review-order-table">
                    <tbody>
                      <tr className="order-subtotal">
                        <th className="white">
                          {wording.checkoutPage.submit.subtotal}
                        </th>
                        <td>
                          <span className="amount white">
                            {`${CURRENCY.B}${formatMoney(subTotal)}`}
                          </span>
                        </td>
                      </tr>

                      {emailShipping || (
                        <tr className="shipping">
                          <th className="white">
                            {wording.checkoutPage.submit.shipping}
                          </th>
                          <td>
                            <span className="white">
                              {`${CURRENCY.B}${formatMoney(shippingCost)}`}
                            </span>
                          </td>
                        </tr>
                      )}
                      {
                        promotion?.responcePromotionitem.some(pro => !!pro.discountItem) && (
                          <tr className='cart-promotion'>
                            <th style={{ color: '#fff' }} colSpan='2'>
                              <div className="mb-10">
                                {wording.cartPage.cartTotal.promotion}
                              </div>
                              {promotion.responcePromotionitem.map((item, index) => (
                                <Fragment key={index}>
                                  {(item.discountItem && item.discountItem.length > 0) && (
                                    <div>
                                      <div>
                                        <ul className='cart-promotion-list'>
                                          {
                                            item.typeOfUsageStr == TYPE_USAGE.ONTOP && item.typePromotion == TYPE_PROMOTION.PercentDiscount
                                              ? (
                                                <li>
                                                  <div className='flex horizontal-between'>
                                                    <div>
                                                      <span>-</span>
                                                      <span>{item.name}</span>
                                                    </div>
                                                    <div className='promotion-price'>
                                                      {`- ${CURRENCY.B}${formatMoney(_.sumBy(item.discountItem, discount => discount.amount * (discount.price - discount.promotionPrice)))}`}
                                                    </div>
                                                  </div>
                                                </li>
                                              )
                                              : item.discountItem
                                                .filter(discount => discount.amount != 0)
                                                .map((discount, index) => (
                                                  <li key={index}>
                                                    <div className='flex horizontal-between'>
                                                      <div>
                                                        <span>-</span>
                                                        {
                                                          item.typeOfUsageStr == TYPE_USAGE.ONTOP && item.typePromotion == TYPE_PROMOTION.Price_Off
                                                            ? ""
                                                            : <span>{discount.name}</span>
                                                        }
                                                        <span>{item.name}</span>
                                                      </div>
                                                      <div className='promotion-price'>
                                                        {`- ${CURRENCY.B}${formatMoney(discount.amount * (discount.price - discount.promotionPrice))}`}
                                                      </div>
                                                    </div>
                                                  </li>
                                                )
                                                )
                                          }
                                        </ul>
                                      </div>
                                    </div>
                                  )}
                                </Fragment>
                              ))}
                            </th>
                          </tr>
                        )
                      }

                      <tr className="order-total">
                        <th className="white">
                          <strong>{wording.checkoutPage.submit.total}</strong>
                        </th>
                        <td>
                          <strong>
                            <span className="amount white">
                              {`${CURRENCY.B}${formatMoney(
                                subTotal -
                                promotiontotal +
                                parseInt(shippingCost)
                              )}`}
                            </span>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                {subTotal - promotiontotal + shippingCost > 0 && (
                  <div className="mb-10" style={{ display: 'flex' }}>
                    <input
                      type="checkbox"
                      className="billing-address-checkbox"
                      checked={TaxInvoiceCheckbox}
                      onClick={event => event.stopPropagation()}
                      onChange={() => this.handleTaxInvoiceCheckbox()}
                    />
                    <span className="order-total ml-10">
                      {wording.checkoutPage.submit.reqInvTax}
                    </span>
                  </div>
                )}

                <div style={{ float: 'right' }}>
                  <button
                    className="btn btn-md btn-color"
                    disabled={!btnPurchaseState}
                    onClick={() => this.handlePurchaseOrder()}>
                    {wording.checkoutPage.submit.purchase}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}

const mapStateToProps = ({
  login,
  cart,
  address,
  checkout,
  taxaddress,
  language,
  payment
}) => ({
  // Address
  userAddress: address.data,
  // Tax Address
  userTaxInvoiceAddressFetching: taxaddress.isFetching,
  userTaxInvoiceAddress: taxaddress.data,
  // Login
  firebaseAuth: login.firebaseAuth,
  isAuthenticated: login.isAuthenticated,
  sfPlusChecked: login.sfPlusChecked,
  firebaseSfPlusUser: login.firebaseSfPlusUser,
  isSfPlusLinked: login.isSfPlusLinked,
  chackBalanceData: login.chackBalanceData,
  // Checkout
  checkOutData: checkout.checkOutData,
  promotionCartSelected: cart.promotionCartSelected,
  promotiontotal: cart.promotiontotal,
  colorselected: cart.colorselected,
  sizeselected: cart.sizeselected,
  buyNow: cart.buyNow,
  // Policy process
  doAfterAcceptPolicy: checkout.doAfterAcceptPolicy,
  // Checkout sfplus payment
  dialogAccountNotLinked: checkout.dialogAccountNotLinked,
  dialogBalance: checkout.dialogBalance,
  dialogValidatePin: checkout.dialogValidatePin,
  validatePinError: checkout.validatePinError,
  orderingFetching: checkout.orderingFetching,
  orderingData: checkout.orderingData,
  orderingError: checkout.orderingError,
  orderingDataError: checkout.orderingDataError,

  sfPlusPaymentDialogSuccess: checkout.sfPlusPaymentDialogSuccess,
  sfPlusPaymentDialogFailed: checkout.sfPlusPaymentDialogFailed,
  sfPlusPaymentError: checkout.sfPlusPaymentError,
  sfPlusPaymentDataError: checkout.sfPlusPaymentDataError,

  //// K-bank gateway
  kBankData: checkout.kBankData,
  ////wording
  wording: language.wording,
  basenameURL: language.basenameURL,

  // Get Payment Type
  paymentType: payment.data,
  defaultCreditCardPaymentGatway: payment.defaultCreditCardPaymentGatway,
  paymentType_sfPlus: payment.paymentType_sfPlus,
  paymentType_qrCode: payment.paymentType_qrCode,

  // ThaiQR
  dialogThaiQR: checkout.dialogThaiQR,
  thaiQRorderingFetching: checkout.thaiQRorderingFetching,
  thaiQRorderingData: checkout.thaiQRorderingData,
  thaiQRorderingError: checkout.thaiQRorderingError,
  thaiQRorderingDataError: checkout.thaiQRorderingDataError,
  promotion: cart.promotion
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      // Policy
      OpenDialogCheckOutPolicy: Actions.OpenDialogCheckOutPolicy,
      // Address
      GetAddress: Actions.GetAddress,
      OpenDialogCreateAddress: Actions.OpenDialogCreateAddress,
      // Tax Address
      GetTaxAddress: Actions.GetTaxAddress,
      OpenDialogCreateTaxAddress: Actions.OpenDialogCreateTaxAddress,
      // Checkout
      FirebaseSfPlusUser: Actions.FirebaseSfPlusUser,
      OpenDialogSfPlusAccountNotLinked:
        Actions.OpenDialogSfPlusAccountNotLinked,
      CloseDialogSfPlusAccountNotLinked:
        Actions.CloseDialogSfPlusAccountNotLinked,
      OpenDialogSfPlusBalance: Actions.OpenDialogSfPlusBalance,
      CloseDialogSfPlusBalance: Actions.CloseDialogSfPlusBalance,
      OpenDialogPhoneNumber: Actions.OpenDialogPhoneNumber,
      CloseDialogPhoneNumber: Actions.CloseDialogPhoneNumber,
      OpenDialogFurtherInformation: Actions.OpenDialogFurtherInformation,
      OpenDialogSfPlusValidatePin: Actions.OpenDialogSfPlusValidatePin,
      CloseDialogSfPlusValidatePin: Actions.CloseDialogSfPlusValidatePin,
      SFPlusValidatePin: Actions.SFPlusValidatePin,
      CloseDialogSfPlusOrderingFailed:
        Actions.CloseDialogSfPlusOrderingFailed,

      CloseDialogSfPlusPaymentSuccess:
        Actions.CloseDialogSfPlusPaymentSuccess,
      CloseDialogSfPlusPaymentFailed: Actions.CloseDialogSfPlusPaymentFailed,

      ClearBuyNow: Actions.ClearBuyNow,

      // K-bank
      CreditCardOrdering: Actions.CreditCardOrdering,
      GetKPaymentHash: Actions.GetKPaymentHash,

      Get2c2pHash: Actions.Get2c2pHash,

      // Payment Method
      GetPaymentType: Actions.GetPaymentType,

      // ThaiQR
      ThaiQRConfirmPayment: Actions.ThaiQRConfirmPayment,
      OpenDialogThaiQR: Actions.OpenDialogThaiQR,
      CloseDialogThaiQR: Actions.CloseDialogThaiQR,
      ThaiQROrdering: Actions.ThaiQROrdering,

      GetShippingCost: Actions.GetShippingCost,

      UpdatePromotion: Actions.UpdatePromotion,

      ClearDiscountCode: Actions.ClearDiscountCode
    },
    dispatch
  )
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CheckoutMain)
);
